import React, {useEffect} from "react";
import { Outlet, Navigate, useParams } from "react-router-dom";
import { Link, useNavigate, useLocation } from "react-router-dom";
import store, {history} from "@/redux/store";
import { batch, connect } from "react-redux";
import AppView from "@/views/App";
import {logoutUser, checkUserAuth} from "@/reducers/Authorisation"
import {setLocation} from "@/reducers/ApplicationReducer";
import { resetState } from "@/reducers/redirect";

import * as UserConst from "actions/userConst";
import { loadCustomer } from "@/reducers/Customer";

const PrivateRoute = ({...props}) => {
    const location = useLocation();
    const urlParams = useParams();
    console.debug("batchItems");

     const dispatchCalls = async () => {
      await store.dispatch( setLocation( {location:location, urlParams: urlParams} ))
      await store.dispatch( loadCustomer( urlParams.id  ) );
  }


  useEffect(() => {
//      store.dispatch( setLocation( {location:location, urlParams: urlParams} ))
      dispatchCalls();
       
   return () => {
//            worker.port.postMessage({type: 'close'});
      //connection.disconnect();
    };
  }, [location]);    
    
    if(props?.APP_PART !== true) {
       return <Navigate to="/login" />; 
    } 
    else 
    /*
    if(props?.redirectTo && props.redirectTo?.to != "" && location.pathname != "/dashboard" && location.pathname != props?.redirectTo?.to) {
        //store.dispatch( resetState(null) );
        return <Navigate to={"/dashboard"} />; 
    } 
    */
    return (
        <>
        <AppView authReducer={props.AuthReducer} key={props?.AuthReducer?.key}>
        <Outlet/>
        </AppView>
        </>
        ); 
}

function mapStateToProps(state) {
    const {AuthReducer, routing,ModalPopupReducer, RedirectReducer} = state
//    const location = useLocation();
    
/*    
    if(RedirectReducer?.redirectTo) {
    
    }
    
if(RedirectReducer?.redirectTo && RedirectReducer?.redirectTo?.to != "" && location.pathname == RedirectReducer.redirectTo.to) {
        store.dispatch( resetState(null) );
    }
*/        
  return {
        AuthReducer,
        routing,
        ModalPopupReducer,
        redirectTo: RedirectReducer.redirectTo,
        changeKey: RedirectReducer.changeKey,
        location 
  };
}
export default connect(mapStateToProps)(PrivateRoute);
